import styled from "styled-components";

export const MainContainer = styled.div`
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;
